// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2m1sZ","legacyBtn":"MutateMid_legacyBtn__2Bj7r"};